<ng-template #legacyTpl>
  <div class="">
    <app-card-document [bodyList]="detailDocumentDistributor" [loading]="isLoading"
                       [title]="'Dokumen Distributor'"></app-card-document>
    <div class="my-7">
      <app-card-document [bodyList]="detailDocumentNpwp" [loading]="isLoading"
                         [title]="'Dokumen NPWP'"></app-card-document>
    </div>
    <div class="my-7">
      <app-card-document [bodyList]="detailDocumentActivation" [loading]="isLoading"
                         [title]="'Dokumen Aktivasi'"></app-card-document>
    </div>
    <div *ngIf="ShowDocumentNonActive">
      <ng-container *ngTemplateOutlet="documentNonActiveTpl"></ng-container>
    </div>
  </div>
  <!--  <app-card-document [bodyList]="detailDocument" [loading]="isLoading" [title]="'Dokumen'"></app-card-document>-->
</ng-template>

<ng-container *ngIf="isEditRequest; else legacyTpl">
  <ng-container *ngIf="!isFinance">
    <div class="">
      <app-card-document [bodyList]="detailDocumentDistributor" [loading]="isLoading"
                         [title]="'Dokumen Distributor'"></app-card-document>
      <div class="my-7">
        <app-card-document [bodyList]="detailDocumentNpwp" [loading]="isLoading"
                           [title]="'Dokumen NPWP'"></app-card-document>
      </div>
      <app-card-document [bodyList]="detailDocumentActivation" [loading]="isLoading"
                         [title]="'Dokumen Aktivasi'"></app-card-document>
    </div>
    <!--    <app-card-document [bodyList]="detailDocument" [loading]="isLoading" [title]="'Dokumen'"></app-card-document>-->
  </ng-container>

  <ng-container *ngIf="documentImageChange | async as docImg">
    <app-card [cardClasses]="docImg.length > 0 ? 'border border-primary mt-7' : 'mt-7'"
              [cardHeaderTitle]="'Dokumen Pembaruan Data'" [titleInBody]="true">
      <ng-container cardBody>
        <ng-container *ngIf="docImg.length; else noDocumentTPL">
          <div class="row mt-7" *ngFor="let doc of docImg; let first = first">
            <div class="col-12 col-lg-3 mb-4">{{ doc.uploaded_date }} :</div>
            <div class="col-12 col-lg-9">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-4 mb-4" *ngFor="let url of doc.url">
                  <app-image-preview [images]="[url]" [openTextLabel]="false" [height]="200"
                                     [titleModal]="doc.uploaded_date"></app-image-preview>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </app-card>
  </ng-container>

  <ng-template #noDocumentTPL>
    <label class="text-gray-400">Dokumen Pembaruan Data tidak tersedia.</label>
  </ng-template>
</ng-container>

<ng-template #documentNonActiveTpl>
  <app-card [cardClasses]="'my-8'" [cardBodyClasses]="'pt-0'" [header]="true">
    <!-- header start -->
    <ng-container cardHeader>
      <h5 class="fw-bolder d-flex w-100 align-items-center mb-0">
        <span>Dokumen Penonaktifan</span>
      </h5>
    </ng-container>

    <ng-container cardBody>
      <div class="row">
        <div class="col-12 col-lg-6">
          <app-document-preview [data]="documentNonActive"></app-document-preview>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-template>
